export const sortChannelsbyFavorites = (channels) => {
  const orderedChannels = [];
  const lsChannels = localStorage.getItem('channelFavorites');
  const favoriteChannels = JSON.parse(lsChannels);

  if (!favoriteChannels) return channels;

  favoriteChannels.forEach((e) => {
    const channel = channels.find((c) => c.id === e);
    orderedChannels.push(channel);
  });

  const rest = channels?.filter((e) => !favoriteChannels.includes(e.id)) || [];
  return [...orderedChannels, ...rest];
};

/**
 * Converts a hex color string to RGB values array
 * @param {string} hex - The hex color code (with or without # prefix)
 * @returns {Array} An array of [r, g, b] values (0-255)
 */
export function hexToRgbArray(hex, fallback = '#000000') {
  hex = hex ?? fallback;
  hex = hex.replace(/^#/, '');

  // Handle both 3-digit and 6-digit formats
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  // Convert to RGB values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Check if the conversion was successful
  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    throw new Error('Invalid hex color format');
  }

  return [r, g, b];
}

/**
 * Get a nested object value dynamically
 * @param obj  - Input Object
 * @param objPath - Array of strings which is being resolved as the path to the nested value
 * @returns the nested value
 */
export const getObjectValue = (obj, objPath) => {
  if (!obj) return null;
  let entry = obj;
  for (const k of objPath) {
    entry = entry[k];
  }
  return entry;
};

export const isUuid = (str) => {
  const rgx = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return rgx.test(str);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUniqueEntries = (arr: any[], path: string[]) => {
  return [
    ...arr
      .reduce((a, c) => {
        a.set(getNestedEntry(c, path), c);
        return a;
      }, new Map())
      .values(),
  ];
};

export const getNestedEntry = (obj, path: string[]) => {
  return path.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), obj);
};

export const createDate = (dateString: string) => {
  try {
    return new Date(dateString.replace(/-/g, '/'));
  } catch (err) {
    return new Date();
  }
};

export const formatDate = (
  dateString: string,
  formatOptions?: Intl.DateTimeFormatOptions,
  locale = 'de-AT',
  relative = false,
) => {
  if (relative) {
    const date = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    if (compareDate.getTime() === today.getTime()) {
      return 'Heute';
    } else if (compareDate.getTime() === tomorrow.getTime()) {
      return 'Morgen';
    } else if (compareDate.getTime() === yesterday.getTime()) {
      return 'Gestern';
    }
  }
  return new Intl.DateTimeFormat(locale, formatOptions ? formatOptions : {}).format(createDate(dateString));
};
